import { ErrorMessageConfig, HttpErrorMessageConfig, resolveErrorMessage } from '@paysera/error-message-resolver';
import { translatorFactory } from '@assetsJsModule/i18next-react';

import sendContactForm from '../services/sendContactForm';
import getRenderedFieldName from '../services/getRenderedFieldName';

const useSendContactForm = async (
    request,
    loaderHandler,
    errorHandler,
    onSuccess,
    onError,
) => {
    const t = translatorFactory('PayseraContactFormBundle');

    try {
        loaderHandler.start();

        await sendContactForm(request);

        onSuccess();
    } catch (error) {
        if (error.response && error.response.status === 429) {
            return;
        }
        const errorMessage = await resolveErrorMessage(
            error,
            (new ErrorMessageConfig(
                new HttpErrorMessageConfig(t('contact_form.failed_to_send')),
                t('contact_form.failed_to_send'),
            )),
        );

        const errors = error.response?.data?.errors || [];
        const isRenderedFieldError = ({ field }) => getRenderedFieldName(field, request.recipient) !== null;
        const fieldErrors = errors.filter(isRenderedFieldError);
        const unhandledErrors = errors.filter(errorItem => !isRenderedFieldError(errorItem));

        // An error with no field to land on (`subject`) would otherwise vanish.
        if (errors.length === 0 || unhandledErrors.length > 0) {
            errorHandler.dispatchError(errorMessage, error);
        }

        if (fieldErrors.length > 0) {
            // Must stay last: it throws SubmissionError.
            onError(fieldErrors);
        }
    } finally {
        loaderHandler.stop();
    }
};

export default useSendContactForm;
